export default {
  settings: {
    languageId: 'en',
  },
  labels: {
    en: {
      'frequency.modal.title': 'Schedule Feed',
      'frequency.modal.edit.title': 'Edit Schedule',
      'frequency.modal.description':
        "Schedule Feeds to run at a specific time and frequency. You can track the progress for this and other runs in the Feed Manager's Schedules tab.",
      'frequency.modal.description.lens':
        'Schedule Feeds to run at a specific time and frequency. You can track the progress for this and other runs in the Schedules section of the Data Feeds page.',
      'frequency.modal.date.label': 'Start',
      'frequency.modal.name.label': 'Name',
      'frequency.modal.name.placeholder': 'Schedule Name',
      'frequency.modal.duplicate.name.error':
        'Schedule name already exists. Please use a different name.',
      'frequency.modal.empty.name.error': 'Please enter a name.',
      'frequency.modal.underflow.name.error':
        'The name should have at least 4 characters.',
      'frequency.modal.invalid.name.error':
        'The name can only include letters, numbers and the following special characters: ., _, (, ), -, &, <, >, ", \', #, $, %, =, :, @, |.',
      'frequency.modal.overflow.name.error':
        'The name may not be longer than 200 characters.',
      'frequency.modal.recurrence.label': 'Recurrence',
      'frequency.modal.daily.label': 'On',
      'frequency.modal.weekly.label': 'Every',
      'frequency.modal.everyday.text': 'Every Day',
      'frequency.modal.weekday.text': 'Weekday (M-F)',
      'frequency.modal.holidays.text': 'Business Day',
      'frequency.modal.monthly.label': 'of the month',
      'frequency.modal.recurrenceoption.OnlyOnce': 'Only Once',
      'frequency.modal.recurrenceoption.Daily': 'Daily',
      'frequency.modal.recurrenceoption.Weekly': 'Weekly',
      'frequency.modal.recurrenceoption.Monthly': 'Monthly',
      'frequency.modal.options.number.text.1': 'First',
      'frequency.modal.options.number.text.2': 'Second',
      'frequency.modal.options.number.text.3': 'Third',
      'frequency.modal.options.number.text.4': 'Fourth',
      'frequency.modal.options.number.text.5': 'Last',
      'frequency.modal.options.number.value.1': 'first',
      'frequency.modal.options.number.value.2': 'second',
      'frequency.modal.options.number.value.3': 'third',
      'frequency.modal.options.number.value.4': 'fourth',
      'frequency.modal.options.number.value.5': 'last',
      'frequency.modal.summary.OnlyOnce': 'Feed runs on',
      'frequency.modal.summary.Daily.Calendar': 'Feed runs every day starting',
      'frequency.modal.summary.Daily.Business':
        'Feed runs every weekday starting ',
      'frequency.modal.summary.Daily.Holiday':
        'Feed runs every business day (excl. holidays) starting ',
      'frequency.modal.summary.Weekly': 'Feed runs every',
      'frequency.modal.summary.Monthly': 'Feed runs on the',
      'frequency.modal.cancel.button': 'Cancel',
      'frequency.modal.save.button': 'Save Schedule',
      'frequency.modal.edit.button': 'Update Schedule',
      'frequency.modal.time.error': 'Choose a time 10 minutes from now.',
      'frequency.modal.triggerFile.check': 'Subscribe to trigger file',
      'frequency.modal.triggerFile.tooltip': `The trigger file is a .txt file with “-trigger" suffix that indicates file transfer is complete and the file is ready for download. 
        For example, if the data feed file is "filename_YYYYMMDD.CSV", a trigger file named "filename_YYYYMMDD_trigger.txt" 
        indicates that the data feed file is ready for you to download.`,
    },
  },
}
